export const myProfileIds = {
  personalDetails: 'PersonalDetails',
  payouts: 'Payouts',
  reports: 'Reports',
  tradingHistory: 'TradeHistory',
  documents: 'Documents',
  security: 'Security',
  helpCenter: 'HelpCenter',
  logout: 'Logout',
  changePlan: 'ChangePlan',
};
